/**
 * Checks if a password meets a specific requirement
 * @param password - The password to check
 * @param requirement - The requirement to check ('length', 'uppercase', 'lowercase', 'number', 'special')
 * @returns true if the password meets the requirement, false otherwise
 */
export function checkPasswordRequirement(password: string, requirement: string): boolean {
  switch (requirement) {
    case 'length':
      return password.length >= 8;
    case 'uppercase':
      return /[A-Z]/.test(password);
    case 'lowercase':
      return /[a-z]/.test(password);
    case 'number':
      return /[0-9]/.test(password);
    case 'special':
      return /[^A-Za-z0-9]/.test(password);
    default:
      return false;
  }
}

/**
 * Validates a password against all requirements
 * @param password - The password to validate
 * @returns null if valid, or an error message string if invalid
 */
export function validatePassword(password: string): string | null {
  if (password.length < 8) {
    return 'Password must be at least 8 characters long';
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }
  if (!/[a-z]/.test(password)) {
    return 'Password must contain at least one lowercase letter';
  }
  if (!/[0-9]/.test(password)) {
    return 'Password must contain at least one number';
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return 'Password must contain at least one special character';
  }
  return null;
}

